"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3770],{

/***/ 3770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_open_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 23 modules
var dialog = __webpack_require__(65518);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./public/assets/icons/ExitPopUp.svg
var ExitPopUp = __webpack_require__(61740);
;// CONCATENATED MODULE: ./components/organisms/pop-up-open-page/PopUpOpenPage.tsx






/**
 * PopUpOpenPage
 */ var PopUpOpenPage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, title = param.title, button = param.button, desc = param.desc, image = param.image, link = param.link, idPopUp = param.idPopUp;
    var ref = (0,react.useState)(false), popUpOpen = ref[0], setPopUpOpen = ref[1];
    var ref1 = (0,react.useState)(0), imageHeigth = ref1[0], setImageHeigth = ref1[1];
    var panel = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var isModalShown = window.sessionStorage.getItem(idPopUp);
        if (isModalShown !== "Shown") {
            setPopUpOpen(true);
            sessionStorage.setItem(idPopUp, "Shown");
        } else {
            setPopUpOpen(false);
        }
    }, []);
    var togglePopUp = function() {
        setPopUpOpen(!popUpOpen);
    };
    (0,react.useEffect)(function() {
        var handleResize = function() {
            var height = window.innerWidth;
            if (height < 1024) {
                setImageHeigth(200);
            } else {
                var ref;
                var ref1;
                //eslint-disable-next-line
                //@ts-ignore
                setImageHeigth((ref1 = panel === null || panel === void 0 ? void 0 : (ref = panel.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 0);
            }
        };
        window.addEventListener("resize", handleResize);
        setTimeout(handleResize, 100);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var _src;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: popUpOpen,
        // eslint-disable-next-line
        onClose: function() {},
        className: "absolute inset-0 z-50 grid place-items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                className: "absolute inset-0 bg-[rgba(21,33,39,0.7)]",
                onClick: togglePopUp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                className: "z-50 flex h-fit w-[calc(100vw-2rem)] flex-col items-center overflow-hidden bg-[#F9F0EB] font-primary  lg:w-[900px] lg:flex-row ".concat(className),
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            height: imageHeigth
                        },
                        className: "relative !min-w-full lg:!min-w-[450px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "fill",
                                objectFit: "cover",
                                src: image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute right-3 top-3 z-50 flex justify-end rounded-full bg-[#F9F0EB] md:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                    heigth: 32,
                                    width: 32,
                                    className: " flex-shrink-0 hover:cursor-pointer",
                                    onClick: togglePopUp
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: panel,
                        className: "flex w-full flex-col gap-8 px-5 py-3 md:gap-4 md:p-5 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden justify-end md:flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                    heigth: 32,
                                    width: 32,
                                    className: " flex-shrink-0 hover:cursor-pointer",
                                    onClick: togglePopUp
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-full flex-col justify-between gap-3 md:gap-14 md:gap-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-heading-mobile--h1 font-normal md:text-heading--h1",
                                                children: title
                                            }),
                                            desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-heading--h5 md:text-heading--h4",
                                                children: desc
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col justify-center gap-3",
                                        children: [
                                            button.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                className: " w-full self-center md:!w-2/3 md:self-start",
                                                size: "large",
                                                as: "a",
                                                href: button.src,
                                                variant: button.variant,
                                                children: button.label
                                            }),
                                            link.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                arrow: true,
                                                className: "flex self-center md:self-start md:pl-2",
                                                variant: link.variant,
                                                href: (_src = link.src) !== null && _src !== void 0 ? _src : "#",
                                                children: link.label
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
PopUpOpenPage.displayName = "PopUpOpenPage";

;// CONCATENATED MODULE: ./components/organisms/pop-up-open-page/index.ts

/* harmony default export */ var pop_up_open_page = (PopUpOpenPage);


/***/ })

}]);